import { Button, Form, Input, Modal, Select, Switch } from "antd";

import { selectFormOptionsNoFormatting } from "../../../../../utils/helper";

const EditDiscordMentorModal = ({
  isModalOpen = false,
  initialValues = {},
  websiteBatchesList = [],
  setIsModalOpen = () => {},
  handleEditMentorModal = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleEditMentorModal(values);
  };

  return (
    <Modal
      title="Edit Mentor"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        initialValues={initialValues || {}}
        name="edit_mentor_modal_form"
        onFinish={handleFormSubmit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the name!"
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="discordUserName" label="Discord User Name">
          <Input />
        </Form.Item>
        {/* <Form.Item name="email" label="Email">
          <Input />
        </Form.Item> */}
        <Form.Item name="mobileNumber" label="Mobile Number">
          <Input />
        </Form.Item>
        <Form.Item
          name="type"
          label="Type"
          rules={[
            {
              required: true,
              message: "Please select a type!"
            }
          ]}
        >
          <Select
            options={selectFormOptionsNoFormatting(["INTERNAL", "EXTERNAL_OLD", "EXTERNAL_NEW"])}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item
          name="batches"
          label="Batches"
          rules={[
            {
              required: true,
              message: "Please select batch(s)!"
            }
          ]}
        >
          <Select mode="multiple" options={websiteBatchesList || []} showSearch allowClear />
        </Form.Item>
        <Form.Item
          name="isActive"
          label="Active/Inactive toggle for Mentor"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default EditDiscordMentorModal;
